import { render, staticRenderFns } from "./SSS.vue?vue&type=template&id=98f12a4e&lang=true&"
import script from "./SSS.vue?vue&type=script&lang=js&"
export * from "./SSS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports